import api from './api';
import auth from './auth';
import cfg from './cfg';
import ui from './ui';

import { tableIconsRecalculate } from './tableIcons';
import tx, { txLoadLang, txloadLang, txSetLang } from './tx';

import { reactive, readonly } from "vue";
import parking from './park/parking';
import vias from './park/vias';
import booking from './park/booking';
import bookingStatus from './park/bookingStatus';
import paymentMethod from './park/paymentMethod';
import invoiceType from './park/invoiceType';
import countDaysMode from './park/countDaysMode';


const state = reactive({
    lang:null,
    username:null,
    colorTheme: localStorage.getItem('colorTheme') ?? cfg.colorTheme,
    fontTheme:  localStorage.getItem('fontTheme')  ?? cfg.fontTheme,
    parking:{id:0, name:'Parking'},
    sessionReady : false
});


async function setLang(langCode) {
    txSetLang(langCode);

    let langCodeSanitized  = tx.getLangCode();

    api.setLang(langCodeSanitized);

    await txLoadLang();
    state.lang = langCodeSanitized;

    tableIconsRecalculate();
    vias.translateNames();
    bookingStatus.translateNames();
    booking.onChangeLang();
    paymentMethod.translateNames();
    invoiceType.translateNames();
    countDaysMode.translateNames();
}

async function loadSessionLang() {
    await setLang(tx.getLangCode());
}

async function initPrivateSession() {
    await auth.loadStoredSession();
    if (!auth.isLoggedIn()) return;
    ui.applyThemes(state.colorTheme, state.fontTheme);
    await loadSessionLang();
    state.sessionReady = true;
}


async function requireSession() {
    if (!state.sessionReady)
        await initPrivateSession();
}


function setColorTheme(colorTheme){
    state.colorTheme =colorTheme;
    localStorage.setItem('colorTheme', colorTheme) ;
    ui.applyThemes(state.colorTheme, state.fontTheme);
}

function setFontTheme(colorTheme){
    state.fontTheme =colorTheme;
    localStorage.setItem('fontTheme', colorTheme) ;
    ui.applyThemes(state.colorTheme, state.fontTheme);
}


function setUsername(name) {
    state.username = name;
}

async function setParking(id) {
    if (state.parking.id ==id)
        return true;


    let result = await api.getId('parking', id);
    if (result.ok) {
        state.parking.id   =result.data.id;
        state.parking.name =result.data.name;
        parking.setIdParking(state.parking.id);
        return true;
    }

    return false;
};


function  sanitizeAlphanumericUpper(text) {
    return text.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function  sanitizeCarPlate(plate) {
    return sanitizeAlphanumericUpper(plate);
}

function  sanitizeDigits(number) {
    return number.replace(/[^0-9]/g, '');
}

export default {
    state: readonly(state),
    setLang,
    setColorTheme, setFontTheme,
    //initPrivateSession,
    setUsername,
    setParking,
    _requireSession:requireSession,
    sanitizeCarPlate, sanitizeDigits, sanitizeAlphanumericUpper
};
